// extracted by mini-css-extract-plugin
module.exports = {"is-preload":"styles-module--is-preload--3Zmhj","title":"styles-module--title--28FID","text":"styles-module--text--89gh4","button":"styles-module--button--1UPuU"};